import React from 'react';
import { BoostModalProvider } from './BoostModalContext';
import { SuggestedProductModalProvider } from './SuggestedProductModalContext';
import { HistoryCheckModalProvider } from './HistoryCheckModalContext';
import { WriteOffModalProvider } from './WriteOffModalContext';
import { SellerAnalyticsModalProvider } from './SellerAnalyticsModalContext';
import { SavedSearchModalProvider } from './SavedSearchModalContext';
import { TrustedDealerModalProvider } from './TrustedDealerModalContext';
import { InAppMessageModalProvider } from './InAppMessageModalContext';

const providers = [
  BoostModalProvider,
  SuggestedProductModalProvider,
  HistoryCheckModalProvider,
  WriteOffModalProvider,
  SellerAnalyticsModalProvider,
  SavedSearchModalProvider,
  TrustedDealerModalProvider,
  InAppMessageModalProvider,
];

const ModalsProvider = ({ children }: { children: React.ReactNode }) =>
  providers.reduceRight(
    (acc, Provider) => <Provider>{acc}</Provider>,
    <>{children}</>,
  );

export default ModalsProvider;
